import React from 'react'
import NumberField from '../../shared/NumberField'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../..'

interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues?: UseFormGetValues<FormValues>
  resetField?: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const Beaches = (props: Props) => {
  const { control } = props
  return (
    <>
      <NumberField
        title="createPropertyAdFields.beaches.label"
        translateTitle
        titleProps={{ required: false }}
        control={control}
        name={'property.beaches' as Path<FormValues>}
      />
    </>
  )
}

export default React.memo(Beaches)
